<template>
  <div class="balance">
    <label>{{label}}</label>
    <div v-if="value" class="value">
      ${{value.toFixed(2)}}
    </div>
    <Loader v-else type="spinner" size="small" color="#768393" />
  </div>
</template>

<script>
import Loader from "@/components/Loader";

export default {
  name: "Balance",
  components: {
    Loader
  },
  props: {
    label: String,
    value: Number,
  }
}
</script>

<style scoped>
.balance {
  display: flex;
  flex-direction: column;
  background: #1E242B;
  border-radius: 12px;
  height: 8vh;
  align-items: center;
  justify-content: center;
}

.value {
  font-weight: bolder;
  font-size: 23px;
  color: #768393;
}
</style>